import {
    MarketResearchCompensationData,
    MarketResearchDiversityData,
    MarketResearchShareData,
    MarketResearchSummaryData,
    MarketResearchSupplyDemandData,
} from "..";
import { RelodeApiError } from "../../../modules";

export type MarketResearchState = {
    summary: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: MarketResearchSummaryData;
    };
    compensation: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: MarketResearchCompensationData;
    };
    supplyDemand: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: MarketResearchSupplyDemandData;
    };
    diversity: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: MarketResearchDiversityData;
    };
    share: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: MarketResearchShareData;
    };
};

export const defaultMarketResearchState: MarketResearchState = {
    summary: {
        isBusy: false,
        data: undefined,
        error: undefined,
    },
    compensation: {
        isBusy: false,
        data: undefined,
        error: undefined,
    },
    supplyDemand: {
        isBusy: false,
        data: undefined,
        error: undefined,
    },
    diversity: {
        isBusy: false,
        data: undefined,
        error: undefined,
    },
    share: {
        isBusy: false,
        data: undefined,
        error: undefined,
    },
};
